import React from 'react'

export default ({ locals, error }) =>
  <div className='render-error' title={String(error.stack)}>
    <div className='error-title'>Part `{locals.label}` failed to render</div>
    <div>
      <code>{error.name}: {error.message}</code>
    </div>
  </div>



// WEBPACK FOOTER //
// ./app/components/ui/RenderError.js